"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaThumbnailWrapper = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var NFTDataContext_1 = require("../context/NFTDataContext");

var useMediaContext_1 = require("../context/useMediaContext");

var MediaThumbnailWrapper = function MediaThumbnailWrapper(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      href = _ref.href,
      className = _ref.className;

  var _a, _b;

  var _useMediaContext_1$us = useMediaContext_1.useMediaContext(),
      getStyles = _useMediaContext_1$us.getStyles;

  var _react_1$useContext = react_1.useContext(NFTDataContext_1.NFTDataContext),
      nft = _react_1$useContext.nft;

  var auctionStatus = (_b = (_a = nft === null || nft === void 0 ? void 0 : nft.data) === null || _a === void 0 ? void 0 : _a.pricing) === null || _b === void 0 ? void 0 : _b.status;
  var LinkComponent = href ? "a" : "button";
  return jsx_runtime_1.jsxs("div", Object.assign({}, getStyles("cardOuter", className, {
    hasClickEvent: !!onClick,
    auctionStatus: auctionStatus
  }), {
    children: [(href || onClick) && jsx_runtime_1.jsx(LinkComponent, Object.assign({}, getStyles("cardLink"), {
      href: href,
      onClick: onClick
    }, {
      children: "View NFT"
    }), void 0), children]
  }), void 0);
};

exports.MediaThumbnailWrapper = MediaThumbnailWrapper;